export default "__VITE_ASSET__XCK0c5Ez__"